import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: "https://82d28d6f3db5487b6dd77b8cf50830d7@o4507089649008640.ingest.de.sentry.io/4508383897059408",
    integrations: [
        Sentry.replayIntegration()
    ],
    replaysOnErrorSampleRate: 1

});
